<div *ngIf="permission?.canSeePfIrfe">
  <div class="header_search">
    <div class="title-page">
      <h3>IRFEs</h3>
    </div>
    <div class="content_search">
      <div class="new-project" *ngIf="permission?.canSave">
        <a class="btn btn-primary" type="btn" routerLink="adicionar">Novo</a>
      </div>
    </div>
  </div>

  <div class="system-table table-container">
    <div class="system-table-conteiner">
      <table>
        <thead>
          <tr>
            <th>Objeto</th>
            <th>Status Operacional</th>
            <th>Data de término da vigência</th>
            <th>Valor de repasse</th>
            <th>Valor de contrapartida</th>
            <th class="text-center btn-icon-td">Ações</th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let item of irfeList">
            <tr>
              <td class="title"><span class="title-span">{{item?.ds_object}}</span></td>
              <td>{{item?.operational_status_label}}</td>
              <td>{{item?.dt_end}}</td>
              <td>{{item?.transfer_value}}</td>
              <td>{{item?.counterpart_value}}</td>
              <td>
                <div class="btn-icon" *ngIf="item?.canSave">
                  <a class="icon-table" [routerLink]="item?.id">
                    <img src="assets/images/svgs/editar1.svg" alt="Editar" tooltip="Editar" placement="bottom">
                  </a>
                </div>
              </td>
            </tr>
          </ng-container>
          <tr *ngIf="!irfeList?.length" class="border-b-radius">
            <td colspan="6" class="text-center">Nenhum IRFE Cadastrado.</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
<app-loading [loader]="isLoading"></app-loading>